module.exports = __webpack_public_path__ + "static/logo-transparent-a02704555354f0c5cdcd5e758286e1b8.png";